export enum CountryCode {
  Nigeria = "NGA",
  EuropeanUnion = "EUE",
  Zambia = "ZMB",
  UnitedStates = "USA",
  UnitedKingdom = "GBR",
  India = "IND",
  Japan = "JPN",
  China = "CHN",
  Canada = "CAN",
  Australia = "AUS",
}

export const countryCurrencies: Record<CountryCode, string> = {
  [CountryCode.Nigeria]: "NGN",
  [CountryCode.EuropeanUnion]: "EUR",
  [CountryCode.Zambia]: "ZMW",
  [CountryCode.UnitedStates]: "USD",
  [CountryCode.UnitedKingdom]: "GBP",
  [CountryCode.India]: "INR",
  [CountryCode.Japan]: "JPY",
  [CountryCode.China]: "CNY",
  [CountryCode.Canada]: "CAD",
  [CountryCode.Australia]: "AUD",
};
